import { ThumbnailItem } from '@ntv360/component-pantry';
import { StatsData } from '@shared';

export const PLAYLISTS_STATS: StatsData[] = [
    {
        title: 'Playlist(s)',
        description: 'Current number of playlists',
        total: '4206',
        iconKey: 'play',
    },
    {
        title: 'New this week',
        description: 'Playlist',
        total: '3',
        iconKey: 'sparkles',
    },
    {
        title: 'New last week',
        description: 'Playlist',
        total: '54',
        iconKey: 'sparkles',
    },
];

export const PLAYLIST_DATA: any[] = [
    {
        id: 1,
        dealerAlias: '482-FL',
        businessName: '482-Aco-miami Beach Coral Gables',
        contantPerson: 'Jane Doe',
        age: '0 month(s)',
        licenses: {
            total: 0,
            unassigned: 0,
            online: 0,
            offline: 0,
        },
        hosts: {
            total: 0,
            scheduled: 0,
            active: 0,
        },
        activeHosts: 0,
        totalAdvertisers: 0,
        activeAdvertisers: 0,
        status: '36 MB/s',
    },
    {
        id: 2,
        dealerAlias: '101-NY',
        businessName: '101-Broadway Digital New York',
        contantPerson: 'John Smith',
        age: '3 month(s)',
        totalLicenses: 12,
        unassignedLicenses: 2,
        onlineLicenses: 8,
        offlineLicenses: 2,
        totalHosts: 5,
        scheduledHosts: 3,
        activeHosts: 4,
        totalAdvertisers: 6,
        activeAdvertisers: 5,
        status: '58 MB/s',
    },
    {
        id: 3,
        dealerAlias: '203-CA',
        businessName: '203-Sunset Media Los Angeles',
        contantPerson: 'Maria Garcia',
        age: '7 month(s)',
        totalLicenses: 20,
        unassignedLicenses: 4,
        onlineLicenses: 14,
        offlineLicenses: 2,
        totalHosts: 10,
        scheduledHosts: 7,
        activeHosts: 9,
        totalAdvertisers: 15,
        activeAdvertisers: 12,
        status: '72 MB/s',
    },
    {
        id: 4,
        dealerAlias: '317-TX',
        businessName: '317-Lone Star Ads Houston',
        contantPerson: 'Carlos Rivera',
        age: '11 month(s)',
        totalLicenses: 35,
        unassignedLicenses: 5,
        onlineLicenses: 22,
        offlineLicenses: 8,
        totalHosts: 18,
        scheduledHosts: 12,
        activeHosts: 15,
        totalAdvertisers: 22,
        activeAdvertisers: 18,
        status: '90 MB/s',
    },
    {
        id: 5,
        dealerAlias: '540-IL',
        businessName: '540-Windy City Media Chicago',
        contantPerson: 'Emily Chen',
        age: '2 month(s)',
        totalLicenses: 8,
        unassignedLicenses: 1,
        onlineLicenses: 5,
        offlineLicenses: 2,
        totalHosts: 4,
        scheduledHosts: 2,
        activeHosts: 3,
        totalAdvertisers: 5,
        activeAdvertisers: 4,
        status: '44 MB/s',
    },
    {
        id: 6,
        dealerAlias: '629-WA',
        businessName: '629-Pacific Reach Seattle',
        contantPerson: 'David Nguyen',
        age: '14 month(s)',
        totalLicenses: 50,
        unassignedLicenses: 8,
        onlineLicenses: 30,
        offlineLicenses: 12,
        totalHosts: 25,
        scheduledHosts: 18,
        activeHosts: 22,
        totalAdvertisers: 30,
        activeAdvertisers: 27,
        status: '110 MB/s',
    },
    {
        id: 7,
        dealerAlias: '755-GA',
        businessName: '755-Peach State Media Atlanta',
        contantPerson: 'Sarah Johnson',
        age: '5 month(s)',
        totalLicenses: 16,
        unassignedLicenses: 3,
        onlineLicenses: 10,
        offlineLicenses: 3,
        totalHosts: 8,
        scheduledHosts: 5,
        activeHosts: 6,
        totalAdvertisers: 10,
        activeAdvertisers: 8,
        status: '62 MB/s',
    },
    {
        id: 8,
        dealerAlias: '868-AZ',
        businessName: '868-Desert Sun Ads Phoenix',
        contantPerson: 'Michael Torres',
        age: '9 month(s)',
        totalLicenses: 28,
        unassignedLicenses: 6,
        onlineLicenses: 18,
        offlineLicenses: 4,
        totalHosts: 14,
        scheduledHosts: 9,
        activeHosts: 11,
        totalAdvertisers: 18,
        activeAdvertisers: 15,
        status: '78 MB/s',
    },
];

/** [Temporary]: Screens (or host) data for the select-screen step */
export const SELECT_HOSTS_DATA: any[] = [
    {
        name: 'Joemar Host',
        host: [
            {
                licenseId: 'd3c25de4-12c8-41e9-a294-300f95e4692f',
            },
            {
                licenseId: 'f887d945-726b-4975-a9ea-8e0fcf2c2e27',
            },
        ],
    },
];
